import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Luo push-ilmoituskampanja',
  sent_title: 'Ilmoitus jonossa',
  sent_subtitle:
    'Push-ilmoituksesi on lähetetty Applelle ja Googlelle. Toimitusvahvistukset saapuvat noin 15 minuutin kuluttua.',
  sent_info_banner: 'Voit sulkea tämän ikkunan. Tarkistamme ja päivitämme kampanjan toimitustilastot automaattisesti.',
  circles: {
    sent_label: 'Lähetetty',
    sent_sub: 'Lähetetty tilaajille',
    delivered_label: 'Toimitettu',
    delivered_sub: 'Odottaa Applea ja Googlea',
    delivered_ready_short: 'Valmis',
    delivered_ready_sub: 'Päivitä nähdäksesi uusimmat tilastot',
  },
  scheduled_title: 'Kampanja ajastettu',
  scheduled_body_line_1: 'Push-ilmoituksesi on ajastettu lähetettäväksi {{when}}.',
  scheduled_body_line_2:
    'Lähetämme sen automaattisesti kyseisenä ajankohtana. Applen ja Googlen toimitusvahvistukset tulevat saataville noin 15 minuutin kuluttua lähetyksestä.',
  recipients_count_one: 'Lähetetty {{count}} tilaajalle.',
  recipients_count_other: 'Lähetetty {{count}} tilaajalle.',
  close: 'Sulje',
  sections: {
    message: 'Viesti',
    audience: 'Kohderyhmä',
    when: 'Milloin lähetetään',
    review: 'Esikatselu',
  },
  stepper: {
    message: 'Viesti',
    audience_when: 'Milloin lähetetään',
    review: 'Esikatselu',
  },
  blocked_reasons: {
    title_required: 'Lisää otsikko jatkaaksesi.',
    body_required: 'Lisää viestin sisältö jatkaaksesi.',
    offer_required: 'Valitse tarjous jatkaaksesi.',
    promo_code_required: 'Valitse alennuskoodi jatkaaksesi.',
    send_option_required: 'Valitse lähetysajankohta jatkaaksesi.',
    scheduled_at_required: 'Valitse päivämäärä ja aika jatkaaksesi.',
  },
  fields: {
    title: {
      label: 'Otsikko',
      placeholder: 'Anna ilmoituksen otsikko',
    },
    body: {
      label: 'Viestin sisältö',
      placeholder: 'Kirjoita viestisi',
    },
    audience: {
      label: 'Kohderyhmä',
    },
    send_options: {
      label: 'Lähetysasetukset',
    },
    date_and_time: {
      label: 'Päivämäärä ja aika',
      placeholder: 'Valitse päivämäärä ja aika',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Lähetä nyt',
    [SendOptions.Schedule]: 'Ajasta',
  },
  send_option_cards: {
    now: {
      title: 'Lähetä nyt',
      description: 'Lähetä kaikille tilaajille heti.',
    },
    schedule: {
      title: 'Ajasta',
      description: 'Valitse päivä ja kellonaika tulevaisuudesta.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Tarjous 🚀',
      description: 'Mainosta tarjousta tai alennuskoodia.',
    },
    informational: {
      title: 'Tiedote ℹ️',
      description: 'Jaa uutisia tai päivitys — ei alennusta mukana.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Kaikki käyttäjät ({{count}} laite)',
  },
  preview: {
    title: 'Esikatselu',
    notifications: {
      title: 'Ilmoituksesi otsikko näkyy tässä',
      body: 'Viestisi sisältö näkyy tässä kaikkine yksityiskohtineen...',
      now: 'Nyt',
    },
    estimated_reach: 'Tavoitettavuus',
  },
  summary: {
    title: 'Yhteenveto',
    reach: 'Tavoitettavuus',
    when: 'Ajankohta',
    campaign_type: 'Kampanjatyyppi',
    promo_code: 'Alennuskoodi',
    offer: 'Tarjous',
    test_audience: 'Lähetä ensin testiviesti',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Päivittäinen lähetysraja saavutettu',
      description:
        'Hei! Useamman kuin yhden push-ilmoituksen lähettäminen päivässä ärsyttää käyttäjiä ja voi johtaa sovelluksen poistamiseen. Siksi rajoitamme manuaaliset lähetykset yhteen päivässä. Ajasta tämä huomiselle.',
    },
    offer_not_sendable: {
      title: 'Tarjous ei ole voimassa tänään',
      description: 'Valitse tuleva päivämäärä.',
    },
  },
  buttons: {
    send_now: 'Lähetä nyt',
    save: 'Tallenna',
    save_as_draft: 'Tallenna luonnoksena',
    send_test: 'Lähetä testi',
    draft_with_ai: 'Luonnostele tekoälyllä',
    back: 'Takaisin',
    next: 'Seuraava',
  },
  feedback: {
    success: 'Kampanja tallennettu onnistuneesti',
    promo_code_expired: 'Alennuskoodi vanhentunut',
    error: 'Kampanjaa ei voitu tallentaa. Tarkista yhteytesi ja yritä uudelleen.',
  },
};
